export default __webpack_public_path__ + "static/media/b777ef87bb1759e70c21d83c2dd9a830.b9bc926d.jpg";